import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
//to do exportColumns excel itrans
export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Κωδικός Διακίνησης'), fieldType: 'TEXT' },
    { fieldName: 'transactionDate', fieldTitle: t('Ημερομηνία Αίτησης'), fieldType: 'DATE' },
    { fieldName: 'notes', fieldTitle: t('Παρατηρήσεις'), fieldType: 'TEXT' },
    { fieldName: 'fromWastereceptionpoint.name', fieldTitle: t('Προέλευση'), fieldType: 'TEXT' },
    { fieldName: 'toWastereceptionpoint.name', fieldTitle: t('Προορισμός'), fieldType: 'TEXT' },
    { fieldName: 'transactionLinesDetails', fieldTitle: t('Στοιχεία Συλλογής'), fieldType: 'TEXT' },
    { fieldName: 'line1Material', fieldTitle: t('Απόβλητο 1'), fieldType: 'TEXT' },
    { fieldName: 'line1Weight', fieldTitle: t('Βάρος 1'), fieldType: 'FLOAT' },
    { fieldName: 'line2Material', fieldTitle: t('Απόβλητο 2'), fieldType: 'TEXT' },
    { fieldName: 'line2Weight', fieldTitle: t('Βάρος 2'), fieldType: 'FLOAT' },
    { fieldName: 'line3Material', fieldTitle: t('Απόβλητο 3'), fieldType: 'TEXT' },
    { fieldName: 'line3Weight', fieldTitle: t('Βάρος 3'), fieldType: 'FLOAT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      console.log('data', data);
      const recs = data.getInternalTransactions.data.map((values) => {
        return {
          ...values,
          transactionLinesDetails:
            values.internalTransactionLines && values.internalTransactionLines.length > 0
              ? values.internalTransactionLines
                  .map(
                    (collection) =>
                      `${collection?.material?.name ?? ''} - ${collection.qty ?? ''}τμχ -${
                        collection.netWeight ?? ''
                      } kg`,
                  )
                  .join(', ')
              : '',
          line1Material: values.internalTransactionLines[0]?.material?.name ?? '',
          line1Weight: values.internalTransactionLines[0]?.netWeight ?? '',
          line2Material: values.internalTransactionLines[1]?.material?.name ?? '',
          line2Weight: values.internalTransactionLines[1]?.netWeight ?? '',
          line3Material: values.internalTransactionLines[2]?.material?.name ?? '',
          line3Weight: values.internalTransactionLines[2]?.netWeight ?? '',
        };
      });
      const trsData = {
        getInternalTransactions: {
          data: recs,
          recordCount: data?.getInternalTransactions?.recordCount,
        },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
    //return [null, { loading: null, data: null }];
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'ITRANS',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
